import React from "react";
import { Construction } from "lucide-react";
import { Card } from "../components/ui/card";

export default function Placeholder({ title, description }) {
  return (
    <Card className="rounded-sm border shadow-none p-12 flex flex-col items-center text-center max-w-xl mx-auto mt-8">
      <div className="h-14 w-14 flex items-center justify-center bg-primary/10 text-primary rounded-sm mb-4">
        <Construction className="h-7 w-7" />
      </div>
      <h3 className="font-heading font-bold text-xl">{title}</h3>
      <p className="text-sm text-muted-foreground mt-2">{description}</p>
      <p className="text-xs text-muted-foreground mt-6 uppercase tracking-widest">Módulo en construcción</p>
    </Card>
  );
}
